export type TabKey =
  | 'columns'
  | 'sample-data'
  | 'lineage'
  | 'files'
  | 'tables'
  | 'schema'
  | 'schemas'
  | 'containers'
  | 'databases'
  | 'mlmodels'
  | 'insights'
  | 'features'
  | 'versions';

export type TabConfig = {
  key: TabKey;
  label: string;
  showCount?: boolean;
  getCount?: () => number;
};

export type AssetTypeKey = 'table' | 'container' | 'database' | 'databaseSchema' | 'service' | 'mlmodel';

export const ASSET_TAB_CONFIGS: Record<AssetTypeKey, TabConfig[]> = {
  service: [
    { key: 'insights', label: '인사이트', showCount: false },
    { key: 'containers', label: '버킷', showCount: true },
    { key: 'databases', label: '데이터베이스', showCount: true },
  ],
  database: [{ key: 'schemas', label: '스키마', showCount: true }],
  databaseSchema: [{ key: 'tables', label: '테이블', showCount: true }],
  table: [
    { key: 'columns', label: '컬럼', showCount: true },
    // KETI 버전 제거
    // { key: 'sample-data', label: '샘플 데이터', showCount: true },
    { key: 'lineage', label: '계보', showCount: false },
  ],
  container: [
    // KETI 버전 제거
    // { key: 'files', label: '파일', showCount: true },
    { key: 'lineage', label: '계보', showCount: false },
  ],
  mlmodel: [
    { key: 'versions', label: '버전', showCount: true },
    { key: 'lineage', label: '계보', showCount: false },
  ],
};
